module.exports = __webpack_public_path__ + "static/media/add.2f39f347.svg";